export default __webpack_public_path__ + "static/media/fw-abigail-er-White Gold.3303a1ef.mp4";